export default function initLandingFilter($){
  const form = document.querySelector('.tours-filter');
  if (!form) return;

  form.addEventListener('change', (e) => {
    const t = e.target;
    if (t && t.type === 'radio') {
      form.submit();
    }
    if (t && t.classList && t.classList.contains('tours-filter__select')) {
      const url = t.value;
      if (url) {
        window.location.href = url;
      }
    }
  });

  if (!$) {
    return;
  }

  function initToursSelectDropdowns() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 575.98px)').matches) {
      return;
    }

    const $select = $('.tours-landing .tours-filter__select');
    if ($select.length === 0 || $select.data('mobileDropdownInit')) {
      return;
    }

    $select.data('mobileDropdownInit', true);

    const selectId = $select.attr('id') || '';
    const $wrapper = $('<div class="nets-select" data-select-id="' + selectId + '"></div>');
    const $trigger = $('<button type="button" class="nets-select__trigger" aria-haspopup="listbox" aria-expanded="false"></button>');
    const $list = $('<div class="nets-select__list" role="listbox"></div>');

    $wrapper.append($trigger, $list);
    $select.after($wrapper);

    function updateTrigger() {
      const text = $select.find('option:selected').text() || $select.find('option').first().text();
      $trigger.text(text);
    }

    function renderOptions() {
      $list.empty();
      $select.find('option').each(function() {
        const $option = $(this);
        const value = $option.attr('value') || '';
        const text = $option.text();
        const $item = $('<button type="button" class="nets-select__option" role="option"></button>');
        $item.text(text);
        $item.attr('data-value', value);
        if ($option.is(':selected')) {
          $item.addClass('is-selected');
        }
        $list.append($item);
      });
      updateTrigger();
    }

    renderOptions();

    $trigger.on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const isOpen = $wrapper.hasClass('is-open');
      $('.nets-select.is-open').removeClass('is-open').find('.nets-select__trigger').attr('aria-expanded', 'false');
      $wrapper.toggleClass('is-open', !isOpen);
      $trigger.attr('aria-expanded', String(!isOpen));
    });

    $list.on('click', '.nets-select__option', function() {
      const value = $(this).attr('data-value');
      $select.val(value);
      $select.trigger('change');
      renderOptions();
      $wrapper.removeClass('is-open');
      $trigger.attr('aria-expanded', 'false');
    });

    $select.on('change.mobileSelect', function() {
      renderOptions();
    });

    $(document).off('click.netsSelectTours').on('click.netsSelectTours', function() {
      $('.nets-select.is-open').removeClass('is-open').find('.nets-select__trigger').attr('aria-expanded', 'false');
    });
  }

  initToursSelectDropdowns();
}
